var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailView',{attrs:{"show":_vm.show,"config":{
    title: '提现记录详情查看'
  }},on:{"update:show":function($event){_vm.show=$event}}},[_c('DetailCard',{attrs:{"title":"提现信息"}},[_c('DescView',{attrs:{"descLabels":_vm.descLabels1,"descDatas":_vm.detail}})],1),_c('DetailCard',{attrs:{"title":"付款信息"}},[_c('DescView',{attrs:{"descLabels":_vm.descLabels2,"descDatas":_vm.detail}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }